'use client';

import { useEffect } from 'react';
import { initializeAttribution } from './attribution';

export function AttributionCapture(){
  useEffect(()=>{ initializeAttribution(); },[]);
  return null;
}
